import {Vector3} from "three";
import create from "zustand";
import {devtools, combine} from "zustand/middleware";
import {Card, Persona, Thumbnails, Presentation} from "../data/types";

export const landscapePoints = [
    // top-left
    new Vector3(-1.76, 1.1, 0.05),
    // top-right
    new Vector3(1.3, .96, 0.05),
    // middle-left
    new Vector3(-1.6, .25, 0.05),
    //middle-right
    new Vector3(1, .25, 0.05),
    //bottom-right
    new Vector3(1.2, -0.85, 0.05),
    //bottom-left
    new Vector3(-1.4, -0.9, 0.05),
] as Vector3[]

export const portraitPoints = [
    // top-left
    new Vector3(-1.13, 1.17, 0.05),
    // top-right
    new Vector3(1.2, .96, 0.05),
    // middle-left
    new Vector3(-1.14, .25, 0.05),
    //middle-right
    new Vector3(1, .25, 0.05),
    //bottom-right
    new Vector3(1.1, -0.85, 0.05),
    //bottom-left
    new Vector3(-1, -1.24, 0.05),
] as Vector3[]

export const useStore = create(
    devtools(
        combine(
            {
                isLoading: true,
                isBlurred: true,
                blobRadius: 0.68,
                isGalleryMode: false,
                isLandingBlurred: true,
                runAnimations: true,
                personas: [] as Persona[],
                thumbnails: {} as Thumbnails,
                selectedCard: {} as Card,
                currentPresentation: {} as Presentation,
                isModalOpen: false,
                selectedPersona: null as null | string,
                isVideoPlaying: false,
                isBGAudioEnabled: false,
                prevBGAudioEnabled: false,
                backgroundAudio: '',
                windowDimensions: {
                    width: null as null | number,
                    height: null as null | number,
                },
                backgroundAudioRef: null as null | HTMLElement,
                selectedAnchorPosition: new Vector3(-0.45, 1, 0.4), // y was -0.7 in bottom position
                disabledAnchorPositions: portraitPoints,
            },
            (set) => ({
                updateBlobRadius: (newRadius: number) =>
                    set(() => ({blobRadius: newRadius})),
                updatePersonas: (personas: Persona[]) => set(() => ({personas})),
                updateThumbnails: (thumbnails: Thumbnails) => set({thumbnails}),
                setDisabledAnchorPoints: (disabledAnchorPositions: Vector3[]) => set({disabledAnchorPositions}),
                setSelectedPersona: (selectedPersona: string | null) =>
                    set((state) => ({
                        isGalleryMode:
                            selectedPersona === null ? Boolean(false) : state.isGalleryMode,
                        isBlurred:
                            selectedPersona === null ? Boolean(false) : state.isBlurred,
                        selectedPersona:
                            selectedPersona === state.selectedPersona
                                ? null
                                : selectedPersona,
                    })),
                setGalleryMode: (isOn: boolean) => set({isGalleryMode: isOn, isBlurred: isOn}),
                setSelectedAnchorPosition: (vector: Vector3) => set({selectedAnchorPosition: vector}),
                setBackgroundAudioRef: (audioRef: HTMLElement) => set({backgroundAudioRef: audioRef}),
                setBackgroundAudio: (src: string) => set({backgroundAudio: src}),
                setIsBlurred: (blur: boolean) => set({isBlurred: blur}),
                setIsLandingBlur: (blur: boolean) => set({isLandingBlurred: blur}),
                setIsVideoPlaying: (isPlaying: boolean) => set({isVideoPlaying: isPlaying}),
                setIsBGAudioEnabled: (isEnabled?: boolean) => set((state) => ({isBGAudioEnabled: isEnabled ?? !state.isBGAudioEnabled})),
                setPrevBGAudioEnabled: (prevState: boolean) => set({prevBGAudioEnabled: prevState}),
                setSelectedCard: (card?: Card) => set({selectedCard: card ?? {} as Card}),
                setBoard: (board? : Presentation) => set({currentPresentation: board ?? {} as Presentation}),
                setIsLoading: (isLoading: boolean) => set({isLoading}),
                setWindowDimensions: (dimensions: { width: number, height: number }) => set({windowDimensions: dimensions}),
                setRunAnimations: (runAnimations: boolean) => set({runAnimations}),
            })
        )
    )
);
